/**
 * API Configuration
 *
 * Exports the backend API URL from environment variables
 */

// Backend URL (from environment or default to localhost)
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

/**
 * Get the API base URL
 */
export function getApiUrl(): string {
  return API_URL
}
